export default "__VITE_ASSET__8b1ddaeb__"